<template>
  <div class="calworkhours-container">
    <el-card class="box-card">
      <el-form :inline="true" class="time-form">
        <div v-for="(item, i) in timeRange" :key="item.id" class="time-row">
          <span class="row-index">{{i}}</span>
          <el-input v-model="item.startTime" placeholder="起始时间 HHmmss" style="width: 150px"></el-input>
          <span class="time-separator">~</span>
          <el-input v-model="item.endTime" placeholder="结束时间 HHmmss" style="width: 150px"></el-input>
          <el-button
            type="danger"
            size="small"
            @click="del_head(i)"
            v-if="!(timeRange.length === i + 1)">删除</el-button>
          <el-button
            type="primary"
            size="small"
            @click="add_head"
            v-if="timeRange.length === i + 1">添加</el-button>
        </div>
      </el-form>
      <el-divider></el-divider>
      <el-row class="result-row">
        <el-button type="primary" @click="cal">计算</el-button>
        <span class="result-msg">{{msg}}</span>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import {zr} from '../api/calWorkHours'
export default {
  name: 'calWorkHours',
  data () {
    return {
      timeRange: [{startTime: '', endTime: ''}],
      msg: ''
    }
  },
  methods: {
    add_head () {
      this.timeRange.push({startTime: '', endTime: ''})
    },
    del_head (i) {
      this.timeRange.splice(i, 1)
    },
    cal () {
      console.log(this.timeRange)
      zr(this.timeRange).then(response => {
        this.msg = response.data
      })
    }
  }
}
</script>

<style scoped>
.calworkhours-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.box-card {
  max-width: 100%;
}
.time-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.time-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.row-index {
  width: 30px;
  color: #999;
}
.time-separator {
  color: #666;
}
.result-row {
  margin-top: 20px;
}
.result-msg {
  margin-left: 20px;
  color: #67c23a;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/calWorkHours.vue